import { render, staticRenderFns } from "./addform.vue?vue&type=template&id=c7eb6890&scoped=true&"
import script from "./addform.vue?vue&type=script&lang=js&"
export * from "./addform.vue?vue&type=script&lang=js&"
import style0 from "./addform.vue?vue&type=style&index=0&id=c7eb6890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7eb6890",
  null
  
)

export default component.exports